export default () => ({
    isLoading: true,
    categories: [],
    items: [],
    item: {},
    currentUser: {},
    activeUserId: 0
})
